import React from 'react';

import { useConditionalLink } from '../../helpers/conditionalLink';

export default function ConditionalLink({ href, children, onClick, ...rest }) {
  const go = useConditionalLink();

  function handleClick(e) {
    e.preventDefault();

    if (onClick) onClick(e);

    go(href);
  }

  return (
    <a href={href || '#'} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
